// Stable category codes are never scores. Keep terminology in one place.
export const DEVELOPMENT_LEVELS = [
  { code: 'level_1', label: 'Geliştirilmeli' },
  { code: 'level_2', label: 'Yeterli' },
  { code: 'level_3', label: 'İyi' },
  { code: 'level_4', label: 'Çok İyi' },
];

export const developmentLevelLabel = (code) => (
  DEVELOPMENT_LEVELS.find(level => level.code === code)?.label || null
);

export const isDevelopmentAssessment = (row) => row?.scoring_mode === 'development';

export const assessmentDevelopmentLevel = (row) => (
  String(row?.result_status || '').toLowerCase() !== 'absent' &&
  isDevelopmentAssessment(row) && developmentLevelLabel(row?.development_level)
    ? row.development_level : null
);
